import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaskInputDirective } from './mask-input.directive';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ MaskInputDirective ],
    exports: [ MaskInputDirective ],
})
export class MaskInputDirectiveModule {}
